import { useRef, useState } from "react"
import { History } from "stateshot"

interface useHistoryStateProps {
  onUndoOrRedo: (elements: { nodes: any[]; edges: any[] }) => void
}

export interface useHistoryStateReturn {
  undo: () => void
  redo: () => void
  canRedo: boolean
  canUndo: boolean
  push: (elements: { nodes: any[]; edges: any[] }) => void
}

function useHistoryState(props: useHistoryStateProps): useHistoryStateReturn {
  const [_refresher, setRefresher] = useState(false)
  const historyState = useRef<History<any>>(
    new History({
      maxLength: 30,
      onChange: (e) => {
        setRefresher((s) => !s)
      },
    }),
  )

  const undoActions = {
    undo: () => {
      const lastState = historyState?.current?.undo().get()
      props.onUndoOrRedo(lastState)
    },
    redo: () => {
      const lastState = historyState?.current?.redo().get()
      props.onUndoOrRedo(lastState)
    },

    canRedo: historyState?.current?.hasRedo,
    canUndo: historyState?.current?.hasUndo,
    push: (elements) => {
      historyState?.current?.push(elements)
    },
  }

  return undoActions
}

export default useHistoryState
